import React from "react"

import { useForm } from "react-hook-form"
import { useDispatch } from "react-redux"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config.ts"
import { ButtonElement } from "@front-shared/elements/button.element.tsx"
import { InputElement } from "@front-shared/elements/input.element.tsx"

import { intakeDemoActionCreators } from "../../actions/intakeDemo.actions"
import type { IIntakeDemoAuthorizationData } from "../../types/data.types.ts"

export const IntakeDemoAuthComponent: React.FunctionComponent = () => {
    const dispatch = useDispatch()

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm()

    const onSubmit = (data: any) => {
        const inputData = data as IIntakeDemoAuthorizationData

        dispatch(intakeDemoActionCreators.authStart(inputData.authToken))
    }

    return (
        <div className="relative">
            <form className="mt-[52px]" onSubmit={handleSubmit(onSubmit)}>
                <InputElement
                    label="Auth Token"
                    type="password"
                    name="authToken"
                    reactHookControl={control}
                    reactHookValidations={{
                        required: FRONT_VALIDATION_CONFIG.required,
                        maxLength: FRONT_VALIDATION_CONFIG.maxLength,
                    }}
                    reactHookErrors={errors}
                />

                <div className="mt-[32px]">
                    <ButtonElement
                        label="Authenticate"
                        type="primary"
                        size="large"
                        htmlType="submit"
                        buttonClassName="w-full"
                    />
                </div>
            </form>
        </div>
    )
}
